export default __webpack_public_path__ + "static/media/rainforest1.220f7153.jpg";